<template>
  <!-- 课程详情 -->
  <div class="detail">
    <div class="detailIn"  v-show="goExamPopShow">

      <!-- 应汇信要求，移除掉鼠标滑入滑出事件 -->
      <!-- @mouseleave="mouseOverState('off')" @mouseover="mouseOverState('on')" -->
      <div class="flex topInfo">
        <div class="videoBox" :class="magnifyState==true?'big':''">
          <video :src="currentKc.videoUrl" controls="controls" ref="video"></video>
          <!-- 遮住视频 -->
          <div class="videoM" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;opacity: 0;" @click="playVideo()"></div>
          <div class="magnify" @click="magnifyState=!magnifyState">
            <img src="/static/images/new/magnify.png" />
          </div>
        </div>
        <div class="textInfo" v-show="!magnifyState">
          <h3>{{currentKc.kcMc}}</h3>
          <p class="studyNum">{{videoDetail.learnCount}}人已学</p>
          <p class="price">{{videoDetail.money==0?'免费':'¥ '+videoDetail.money}} <span style="font-size: 16px;" v-show="videoDetail.lxName == '企业信用课程' && videoDetail.money">起</span></p>
          <div class="flex score">
            <span>服务平均分</span>
            <span class="rate">
              <el-rate v-model="rateNum" disabled text-color="#ff9900" score-template="{value}">
              </el-rate>
            </span>
            <span>评价总数 {{count}}</span>
          </div>
          <div class="flex operation">
            <el-button class="but1" type="primary" round @click="playVideo()">{{learningState==true?'立即学习':'暂停播放'}}</el-button>
            <!-- <el-button class="but2" plain round>免费试看</el-button> -->
          </div>
        </div>
      </div>

      <div class="flex middle">
        <div class="flex tabs">
          <div class="flex tab tab1" :class="active==1?'active':''" @click="active=1" style="cursor: pointer;">
            <span class="iconBox">
              <img src="static/images/new/kcjj.png">
            </span>
            <div class="tit">课程简介</div>
          </div>
          <div class="flex tab tab2" :class="active==2?'active':''" @click="active=2" style="cursor: pointer;">
            <span class="iconBox">
              <img src="static/images/new/study.png" />
            </span>
            <div class="tit">学习进度</div>
          </div>
          <div class="flex tab tab3" :class="active==3?'active':''" @click="active=3" style="cursor: pointer;">
            <span class="iconBox">
              <img src="static/images/new/pl.png" />
            </span>
            <div class="tit">评论（{{count}}）</div>
          </div>
        </div>
        <div class="select">
          <div class="yc">
            <el-select v-model="selectValue" value-key="id" placeholder="请选择" @change="selectChange">
              <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="xs" style="cursor: pointer;">
            <span>{{selectValue.name}}</span><span>【{{sfQyfr==0?'经办人':'法人'}}】</span>
            <!-- <span><i class="el-icon-caret-bottom" color="#D3D2D2"></i></span> -->
          </div>



        </div>
      </div>

      <div class="flex content">
        <div class="flex5 fl " v-if="active!=3">
          <!-- 课程简介 -->
          <div class="cont cont1" v-if="active==1">
            <div class="tit">{{currentKc.kcJs}}</div>
            <div class="dataCont" v-html="videoDetail.announcementMag">
            </div>
          </div>
          <!-- 学习进度 -->
          <div class="cont cont2" v-if="active==2">
            <div class="flex tit"> <span></span> <span>{{videoDetail.lxName}}培训需完成{{parseInt(videoDetail.lxTime/60)}}分钟的课时培训，您当前已参加培训{{parseInt(videoDetail.completedTime/60)}}分钟</span>
            </div>
            <ul class="contList">
              <!--  -->
              <li class="flex" :class="currentKc.kcId==item.kcId?'active':''" v-for="(item,index) in kcList" :key="index"
                @click="currentKc = item" style="cursor: pointer;">
                <div class="flex lf">
                  <div class="tag">视频</div>
                  <div class="studyCont">
                    <h3>{{item.kcMc}}</h3>
                    <!--finish完成 continue学习中,未看完 notStart未开始-->
                    <p class="state " :class="item.sfkw==0?'continue':(item.sfkw==1?'finish':'notStart')">{{item.sfkw==1?'已完成该课程的学习':(item.sfkw==0?'上次看到 '+timeNumber(item.xbjl):'还未开始学习该课程')}}</p>
                  </div>
                </div>
                <div class="flex lr">
                  <span class="icon">
                    <img src="/static/images/new/icon.png" />
                  </span>
                  <span class="time">{{timeNumber(item.kcSc)}}</span>
                </div>
              </li>

              <!--  -->
            </ul>
          </div>
          <!-- 评论 -->
          <!-- <div class="cont cont3" v-if="active!=3">
          </div> -->

        </div>
        <!-- 评价-->
        <div class="flex2 fr">
          <div class="tit">评价</div>

          <div class="flex middle2" v-show="active==3">
            <div class="flex left">
              <span>服务平均分</span>
              <span class="rate">
                <el-rate v-model="rateValue" disabled text-color="#ff9900" score-template="{5}">
                </el-rate>
              </span>
              <span class="evaluateNumber">评价总数 {{count}}</span>
            </div>
            <div class="right">
              <el-button class="but" round @click="dialogVisible=!dialogVisible">写评论</el-button>
            </div>
          </div>

          <ul class="evaluateCont">
            <li v-for="(item,index) in commentList">
              <div class="flex user">
                <div class="headImg">
                  <img src="https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3947572783,1476163811&fm=26&gp=0.jpg" />
                </div>
                <div class=" bot">
                  <div class="companyName">{{item.qyName}}</div>
                  <div class="rate">
                    <el-rate v-model="rateValue" disabled text-color="#ff9900" score-template="{value}">
                    </el-rate>
                  </div>
                </div>
              </div>
              <div class="text">
                {{item.content}}
              </div>
            </li>

          </ul>
          <div class="flex more" v-if="count>pageSize">
            <el-button class="but" type="primary"  @click="getMore()">查看更多</el-button>
          </div>
        </div>


      </div>
    </div>

    <!-- 立即购买 未被使用的弹框 -->
    <el-dialog title="购买课程" :visible.sync="buyDialog" width="548px" :before-close="handleClose">
      <div class="buyInfo">
        <!-- 购买信息 -->
        <h3>行政处罚与修复培训</h3>
        <div class="buyNumber">{{this.price}}元</div>
        <p>购买该课程后永不过期,无限观看</p>
      </div>
      <div class="buyMode">
        <div class="tit">
          <span>请选择充值方式</span>
          <span>付款金额:</span>
          <span>{{this.price}}元</span>
        </div>
        <div class="buyCont">
          <!-- 购买方式 -->
          <div class="buyIcon">
            <img src="/static/images/new/zfbIcon.png" />
          </div>
          <div class="flex payBox">
            <el-button type="primary" class="pay" @click="">支付宝支付</el-button>
          </div>
          <p>支付即同意《汇信云课堂服务协议》</p>
        </div>

      </div>

    </el-dialog>

    <!-- 弹框 写评论-->
    <el-dialog title="写评论" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <div class="textarea">
        <el-input resize="none" :rows="11" type="textarea" maxlength="200" show-word-limit placeholder="请输入想说的话"
          v-model="content">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" round @click="commentClick()">发表评论</el-button>
      </span>
    </el-dialog>

    <!-- 考试弹框 -->
    <ksts @backGoVideo="backGoVideo" ref="kst" :kclx="lxId" :lxKsgn="lxKsgn"></ksts>

    <!-- 验证滑块 -->
    <div class="item-font" v-if="flag">
      <div class="slide-item">
        <slide-verify
          ref="slideblock"
          @again="onAgain"
          @fulfilled="onFulfilled"
          @success="onSuccess"
          @fail="onFail"
          @refresh="onRefresh"
          :accuracy="accuracy"
          slider-text="向右滑动"
          :imgs="imgs"
          class="item-text"
        ></slide-verify>
      </div>
      <!-- <div>{{msg}}</div> -->
      <!-- <button @click="handleClick">刷新</button> -->
    </div>

  </div>
</template>

<script>
  import ksts from '@/components/exam/ksts'
  export default {
   components: {
     ksts
   },
    props: ['sfQyfr'],
    data() {
      return {
        buyDialog: false, //购买弹框
        magnifyState: false, //放大
        dialogVisible: false, //评论弹框
        videoTime: null, //视频总时长
        currentTime: null, ///视频播放时间 s
        playEnd: 0, //播放状态 是否看完 1看完 0未看完
        videoDetail: {}, //课程详请数据
        currentKc: {}, //当前正在观看视频
        kcList: [], //课程列表
        exam: false, //去考试状态
        lxKsgn:0,//是否考试
        goExamPopShow:true,//展示内容
        commentList: [], //评论列表
        learningState: true, //学习按钮状态 播放状态相反
        page: 1,
        pageSize: 5,
        count: null, //总页数
        price: null,
        active: 1, //tab切换
        qyId: null, //企业id
        lxId: null, //类型id
        content: '', //内容
        submitFlag: false,
        rateNum: 5, //五星好评
        rateValue: 5, //五星好评
        selectValue: {},
        selectXs: '',
        options: [],
        flag: false,
        totalTiem: 1800, //拼图弹窗倒计时10分钟
        tiem: null, //定时器
        imgs: ["/static/images/xinyon.jpg","/static/images/xinyon2.jpg"],
        accuracy: 1, // 精确度小，可允许的误差范围小；为1时，则表示滑块要与凹槽完全重叠，才能验证成功。默认值为5
        msg: '',
        myVideo: null,
      }
    },
    created() {
      console.log('created -> 滑块验证剩余时长', this.totalTiem);
      this.lxId = this.$route.query.lxId;
      this.qyId = this.$route.query.qyId;
      this.getDetail();
      this.getcompanyList();
      this.getPrice();
      this.getPlList();
    },
    mounted() {
      let video = this.$refs.video;
      video.addEventListener('waiting', () => { //加载
        // console.log("加载中");
      });
      video.addEventListener('loadedmetadata', () => { //加载数据
        //视频的总长度
        this.videoTime = video.duration;
        console.log(this.timeNumber(this.$refs.video.duration), 'sp总时长');
        video.currentTime = this.currentKc.xbjl;

      });
      video.addEventListener('play', () => { //播放开始执行的函数
        console.log("开始播放，滑块验证剩余时长", this.totalTiem);
        this.learningState = false;
        if (this.currentKc.xbjl == video.duration) {
          video.currentTime = 0;
        }
        // 定时器
        this.tiem = setInterval(() => {
          this.totalTiem--;
          console.log(this.totalTiem);
          if (this.totalTiem <= 0) {
            this.$refs.video.pause();
            this.flag = true;
            clearInterval(this.tiem);
          }
        }, 1000);
      });
      video.addEventListener('playing', () => { //播放中
        // console.log("播放中");
      });
      video.addEventListener('pause', () => { //暂停开始执行的函数
        clearInterval(this.tiem);
        console.log("暂停播放，滑块验证剩余时长", this.totalTiem);
        this.currentTime = video.currentTime;
        this.learningState = true;
        // console.log()
        if (this.videoTime <= this.currentTime) {
          this.playEnd = 1;
        } else if (this.currentKc.xbjl <= this.currentTime) {
          this.playEnd = 0;
        } else {
          // console.log('重复观看')
        }
        this.watchVideo();
        // this.taggedVideo();
      });


    },
    methods: {
      //返回继续观看视频
      backGoVideo() {
        this.$refs.kst.ksShow = false;
        this.goExamPopShow = true;
      },
      selectChange(val) {
        console.log(this.selectValue, '对象')
        // this.selectXs
        console.log(val)

      },
      mouseOverState(val) {
        if (val == 'on') {} else if (val == 'off') {
          // setTimeout(()=>{
          // },2000);
          if (this.learningState == false) {
            this.learningState = true;
            this.$refs.video.pause();
            this.$message({
              message: '观看视频过程中请不要将鼠标移出视频区',
              type: 'warning'
            });
          }
        }

      },
      //立即学习按钮
      playVideo() {
        if (this.learningState == true) {
          this.$refs.video.play();
          this.learningState = false;
          // this.$message('观看视频过程中请不要将鼠标移出视频区');
        } else {
          this.$refs.video.pause();
          this.learningState = true;
        }
      },
      // 观看视频
      watchVideo() {
        // console.log(item)
        let ajax = this.$http.create();
        ajax.post(SOWINURL + 'XxKh/getEnterpriseCenter', {
          lxId: this.lxId,
        }).then(res => {
          if (res.data.result == 1) {
            this.taggedVideo();
          }
        }).catch(err => {
          console.log(err)
        })
      },
      //课程切换,以及课程观看进度
      taggedVideo() {
        let ajax = this.$http.create();
        ajax.post(SOWINURL + 'XxKh/taggedVideo', {
          kcId: this.currentKc.kcId,
          lxId: this.lxId,
          spxbSfkw: this.playEnd,
          qyId: this.qyId,
          spxbXbjl: this.currentTime
        }).then(res => {
          if (res.data.result == 1) {
            this.getDetail()
          }
        }).catch(err => {

        })
      },
      // 转换
      timeNumber(val) {
        if (val < 10) {
          return '0:' +  this.timeT(val);
        } else {
          let second, minuteVal, minute, hour;
          if (val >= 60) {
            minuteVal = parseInt(val / 60);
            second = val - minuteVal * 60;
            if (minuteVal >= 60) {
              hour = parseInt(minuteVal / 60);
              minute = minuteVal - hour * 60;
              return this.timeT(hour) + ':' + this.timeT(minute) + ':' + this.timeT(second);
            } else {
              return this.timeT(minuteVal) + ':' + this.timeT(second);
            }
          } else {
            return '0:' + val;
          }

        }
      },
      timeT(val) {
        if (val < 10) {
          return '0' + val;
        } else {
          return val;
        }
      },
      // 公司，企业列表/
      getcompanyList() {
        this.$http.get(SOWINURL + 'index/queryUserEnterprise', {

        }).then(res => {
          if (res.data.result == 1) {
            this.options = res.data.data;
            this.selectValue = this.options[0];
          }
        }).catch(err => {

        })
      },

      //下面这块是拼图验证的
      onSuccess() {
        this.totalTiem = 1800;
        console.log("验证通过");
        this.$refs.video.play();
        this.flag = false;
      },
      onFail() {
        console.log("验证不通过");
        this.msg = "";
      },
      onRefresh() {
        console.log("点击了刷新小图标");
        this.msg = "";
      },
      onFulfilled() {
        console.log("刷新成功啦！");
      },
      onAgain() {
        console.log("检测到非人为操作的哦！");
        this.msg = "try again";
        // 刷新
        this.$refs.slideblock.reset();
      },

      // 转换秒
      // timeT(val){
      //     if(val<60){
      //        return '00:'+val;
      //     }else {
      //        let minute=parseInt(val/60);
      //        let second=val-minute*60;
      //        if(minute<10){
      //          if(){

      //          }
      //          return '0'+minute+':'+val;
      //        }else{
      //          if(minute>60){
      //            let hour=parseInt(minute/60);
      //            if(hour<10){
      //              // return '0'+hour+':'+
      //            }
      //          }else{

      //          }
      //        }
      //     }
      // },
      // 查看更多
      getMore() {
        this.pageSize+=5;
        this.getPlList();
      },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      // 获取详情
      getDetail() {
        this.$http.post(SOWINURL + 'XxKh/getVideoDetail', {
          lxId: this.lxId,
          qyId: this.qyId,
          kcId: null
        }).then(res => {
          if (res.data.result == 1) {
            let data = res.data.data;
            this.kcList = data.kcList;
            this.videoDetail = data;
            this.currentKc = data.currentKc;
// && this.videoDetail.completedTime >= this.videoDetail.lxTime
            if (this.exam == false && this.videoDetail.completedTime >= this.videoDetail.lxTime) {
              setTimeout(() => {
                this.exam = true;
                this.lxKsgn=1;
                this.goExamPopShow=false;
                this.$refs.kst.ksShow = true;
              }, 4000)

            }
            //
          }
        }).catch(err => {

        })
      },
      // 价格获取
      getPrice() {
        this.$http.get(SOWINURL + 'payment/getZfmx', {
          params: {
            qyId: this.qyId,
            lxId: this.lxId
          }
        }).then(res => {
          if (res.data.result == 1) {
            this.price = res.data.data.zje;
          }
        }).catch(err => {

        })

      },
      // 支付宝
      // alipay() {
      //   this.$http.post(SOWINURL + 'payment/alipay', {

      //   }).then(res => {
      //     if (res.data.result == 1) {

      //     }
      //   }).catch(err => {

      //   })
      // },
      // 获取评论列表
      getPlList() {
        this.$http.get(SOWINURL + 'comment/commentList', {
          params: {
            lxId: this.lxId,
            page: this.page,
            pageSize: this.pageSize
          }
        }).then(res => {
          if (res.data.result == 1) {
            let data = res.data.data;
            this.commentList = data.indexPlVos;
            this.count = data.count;
          }
        }).catch(err => {

        })
      },
      // 点击 写评论
      commentClick() {
        if (this.content.replace(/\s*$/g, "") == "") {
          this.$message.error('请输入评论!');
          this.content = "";
        } else {
          this.content = this.content.replace(/\s*$/g, "");
          this.addComment();
        }
      },
      // 发表评价
      addComment() {
        if (this.submitFlag) {
          console.log('repeat operate.')
          return false;
        }
        this.submitFlag = true;
        this.$http.post(SOWINURL + 'comment/addComment', {
          content: this.content,
          lxId: this.lxId,
          qyId: this.qyId
        }).then(res => {
          this.submitFlag = false;
          if (res.data.result == 1) {
            this.$message.success('评论成功!');
            this.content = "";
            this.dialogVisible = false;
            this.getPlList();
          } else {
            this.$message({
              showClose: true,
              message: res.data.errorcode,
              type: "error",
            });
          }
        }).catch(err => {

        })
      }
    }
  }
</script>

<style scoped lang="less">
  .item-font {
    position: absolute;
    top: 0;
    font-size: 14px;
    width: 100%;
    height: 100vh;
    z-index: 999;
    background: rgba(0, 0, 0, 0.6);
  }

  .slide-item {
    width: 310px;
    margin: 150px auto;
  }

  /deep/ .el-dialog__body {
    padding-bottom: 24px;
  }

  /deep/ .el-dialog {
    background: #FFFFFF;
    border-radius: 16px;
  }

  /deep/ .el-dialog__header {
    background: #F5F9FC;
    border-radius: 16px 16px 0 0;
    padding: 19px 20px;
  }

  /deep/ .el-icon-close {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    line-height: 22px;
    background-color: rgb(201, 201, 206, 0.8);
  }

  /deep/ .el-textarea__inner {
    background-color: #F5F5F5;
    padding-top: 16px;
    padding-bottom: 16px;
  }

  /deep/ .el-input__count {
    background-color: #F5F5F5;
  }

  /deep/ .el-dialog__footer {
    display: flex;
    justify-content: center;
    padding-top: 0;
  }

  /deep/.el-dialog__headerbtn .el-dialog__close {
    color: #FFFFFF;
  }

  .flex {
    display: flex;
  }

  .flex1 {
    flex: 1;
  }

  .flex2 {
    flex: 2;
  }

  .flex5 {
    flex: 5;
  }

  .detail {
    background-color: #F7F7F7;
  }

  .detailIn {
    width: 1180px;
    margin: 0 auto;
  }

  .topInfo {
    margin-bottom: 28px;

    .videoBox {
      flex: 3;
      height: 400px;
      background-color: #CCCCCC;
      position: relative;

      video {
        width: 100%;
        height: 100%;
        object-fit: fill;
      }

      .magnify {
        position: absolute;
        bottom: 14px;
        right: 16px;
        width: 36px;
        height: 36px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .big {
      height: 715px;
    }

    .textInfo {
      flex: 2;
      padding: 32px 20px;
      box-sizing: border-box;
      background-color: #FFFFFF;
      border-radius: 0 15px 15px 0;

      h3 {
        margin-bottom: 16px;
        font-size: 24px;
        font-weight: bold;
        color: #312120;
      }

      .studyNum {
        margin-bottom: 32px;
        font-size: 14px;
        font-weight: 400;
        color: #B5B5B5;
      }

      .price {
        font-size: 20px;
        font-weight: bold;
        color: #FF7327;
        margin-bottom: 33px;
      }

      .score {
        margin-bottom: 110px;
        width: 363px;
        height: 24px;
        line-height: 24px;
        box-sizing: border-box;
        background: linear-gradient(90deg, #F6FBFF 0%, #EDF9FF 100%);
        border-radius: 12px;
        font-size: 14px;
        font-weight: 500;
        color: #646464;
        justify-content: center;

        .rate {
          margin-left: 8px;
          margin-right: 40px;
          display: flex;
          align-items: center;
        }
      }

      .operation {

        .but1 {
          font-size: 18px;
          font-weight: bold;
          color: #FFFFFF;
          // line-height: 18px;
        }

        .but2 {
          font-size: 18px;
          font-weight: bold;
          color: #4698FF;
          margin-left: 23px;
          border: 1px solid #4698FF;
          // .el-button
        }
      }
    }
  }

  .middle {
    width: 100%;
    background-color: #FFFFFF;
    height: 68px;
    border-radius: 8px;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .tabs {
      margin-left: 8px;
      align-items: center;

      .tab {
        position: relative;
        font-size: 18px;
        font-weight: 400;
        color: #312120;
      }

      .tit {
        margin-left: 2px;
      }

      .active::after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 50%-5px;
        width: 20px;
        height: 4px;
        background: #F49228;
        border-radius: 2px;

      }

      .tab2,
      .tab3 {
        margin-left: 70px;
      }
    }

    .select {
      margin-right: 32px;
      position: relative;


      .xs {
        i {
          font-size: 24px;
        }

        span {
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 18px;
        }

        span:first-child {
          color: #007AFF;
          border-bottom: 1px solid #007AFF;
        }

        span:nth-child(2) {
          color: #ED2725;
          border-bottom: 1px solid #ED2725;
        }

        /deep/.el-icon-caret-bottom {
          color: #D3D2D2;
        }
      }

      .yc {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;

        /deep/ .el-select {
          width: 100%;
        }

        /deep/.el-input {
          height: 25px;
        }
      }

    }
  }

  .content {
    padding-bottom: 105px;

    .cont {
      background-color: #FFFFFF;
      min-height: 400px;
      padding: 27px 18px;
      margin-right: 16px;
    }

    .cont1 {
      .tit {
        font-size: 18px;
        font-weight: 400;
        color: #959190;
        margin-bottom: 12px;
      }
    }

    .cont2 {
      .tit {
        background: #F5F9FC;
        height: 48px;
        line-height: 48px;
        width: 100%;
        padding-left: 15px;
        box-sizing: border-box;
        margin-bottom: 4px;

        font-size: 16px;
        font-weight: bold;
        color: #8B99AF;
        align-items: center;

        span:first-child {
          display: block;
          width: 8px;
          height: 8px;
          margin-right: 8px;
          border-radius: 50%;
          background-color: #8B99AF;
        }
      }

      .active {
        // background-color: #f3f3f3;

        h3 {
          color: #fb7b4b;
        }
      }

      li {
        padding: 18px 15px;
        justify-content: space-between;

        .lf {
          align-items: baseline;

          .state {
            font-size: 14px;
            font-weight: 400;
          }

          // 完成
          .finish {

            color: #007AFF;
          }

          // 学习中
          .continue {

            color: #2DB45E;
          }

          // 未开始
          .notStart {
            color: #B5B5B5;
          }

        }

        .lr {
          align-items: baseline;

          .icon {
            display: block;
            margin-right: 8px;
            line-height: 16px;
            width: 16px;
            height: 16px;

            img {
              width: 16px;
              height: 16px;
            }
          }

          .time {
            font-size: 14px;
            font-weight: bold;
            color: #B5B5B5;
          }
        }

        h3 {
          font-size: 14px;
          font-weight: bold;
          color: #20242A;
        }

        .tag {
          margin-right: 16px;
          border-radius: 2px;
          border: 1px solid #91959A;
          width: 28px;
          height: 16px;
          line-height: 16px;
          text-align: center;
          font-size: 10px;
          font-weight: 400;
          color: #5B6066;
        }
      }

      li:hover {
        box-shadow: 0px 2px 6px 0px #cccccc;
      }

    }

    .fr {
      background-color: #FFFFFF;

      .tit {
        height: 69px;
        padding-left: 24px;
        line-height: 69px;
        font-size: 18px;
        font-weight: 400;
        color: #312120;
        border-bottom: 1px solid #F0F2F4;
      }

      // 写评论
      .middle2 {
        border-radius: inherit;
        height: 56px;
        background: linear-gradient(90deg, #FFFAF6 0%, #FFF4ED 100%);
        padding-left: 32px;
        box-sizing: border-box;
        align-items: center;
        justify-content: space-between;

        span:first-child {
          margin-right: 10px;
          font-size: 18px;
          font-weight: 500;
          color: #646464;
        }

        .rate {}

        .evaluateNumber {
          margin-left: 64px;
          font-size: 18px;
          font-weight: 500;
          color: #646464;
        }

        .right {
          margin-right: 57px;

          .but {
            background-color: #F49228;
            color: #ffffff;
            font-size: 18px;
            font-weight: 500;
            color: #FFFFFF;
          }
        }
      }

      .evaluateCont {
        max-height: 800px;
        overflow: auto;
        padding-bottom: 20px;
        // overflow-y:scroll;
        li {
          padding-left: 32px;
          padding-top: 24px;
          padding-right: 29px;

          .user {
            margin-bottom: 16px;
          }

          .headImg {
            height: 36px;
            width: 36px;
            margin-right: 9px;
            border-radius: 50%;
            overflow: hidden;

            // box-shadow: 1px 1px 1px 1px #CCCCCC;
            img {
              width: 100%;
              height: 100%;
            }
          }

          .companyName {
            margin-bottom: 3px;
            font-size: 14px;
            font-weight: bold;
            color: #646464;
          }

          .text {
            font-size: 14px;
            font-weight: 400;
            color: #202631;
          }


        }
      }

      .more {
        margin-top: 40px;
        justify-content: center;
        margin-bottom: 32px;

        .but {
          margin: 0 auto;
          padding: 0;
          width: 108px;
          height: 34px;
          background: #2090FF;
          border-radius: 8px;
          line-height: 34px;
        }
      }
    }
  }

  .buyInfo {
    background-image: url(/static/images/new/buyInfo.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    // width: 497px;
    width: 100%;
    height: 207px;
    padding: 43px 0 30px 0;
    text-align: center;
    box-sizing: border-box;

    h3 {
      font-size: 22px;
      font-weight: bold;
      color: #3A3A3A;
      margin-bottom: 13px;
    }

    >div {
      font-size: 46px;
      font-weight: 500;
      color: #FF6627;
      line-height: 65px;
      margin-bottom: 12px;
    }

    p {
      font-size: 16px;
      font-weight: 500;
      color: #9C9C9C;
      line-height: 22px;
    }

  }

  .buyMode {
    .tit {
      margin-top: 28px;
      margin-bottom: 35px;

      span:first-child {
        font-size: 16px;
        font-weight: 500;
        color: #404041;
        line-height: 22px;
      }

      span:nth-child(2) {
        margin-left: 32px;
        font-size: 16px;
        font-weight: 400;
        color: #5D5D5F;
        line-height: 22px;
      }

      span:nth-child(3) {
        color: #FF7800;
        line-height: 22px;
        font-size: 16px;
        font-weight: bold;
      }
    }

    .buyCont {
      text-align: center;
      width: 100%;

      .buyIcon {
        width: 168px;
        height: 168px;
        margin: 0 auto;
        margin-bottom: 16px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .payBox {
        justify-content: center;
        width: 100%;
      }

      .pay {
        width: 168px;
        height: 36px;
        background: #0295E5;
        margin-bottom: 33px;
      }

      p {
        font-size: 16px;
        font-weight: 500;
        color: #A6A6A6;
        line-height: 22px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/courseDetail.vue